import React, { useState } from 'react';
import { sendOtp, verifyOtp } from '../../api/auth';

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [step, setStep] = useState(1);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(null);

  const handleSendOtp = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await sendOtp(email);
      setStep(2);
    } catch (err) {
      setError('Failed to send OTP. Please check your email.');
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const token = await verifyOtp(email, otp);
      setToken(token);
      onLogin(token); // Pass token to parent (App)
    } catch (err) {
      setError('Invalid OTP');
    } finally {
      setLoading(false);
    }
  };

  if (token) return null; // Hide login after verification

  return (
    <div style={{ maxWidth: 340, margin: '60px auto', padding: 24, borderRadius: 12, boxShadow: '0 2px 16px #eee', background: '#fff' }}>
      <h2 style={{ textAlign: 'center', marginBottom: 12 }}>Welcome to <span style={{ color: '#2d7d46' }}>ddhyaan</span></h2>
      <div style={{ textAlign: 'center', fontSize: 14, color: '#555', marginBottom: 20 }}>
        <p><strong>What is ddhyaan?</strong> A focus timer to boost productivity.</p>
        <p><strong>How it helps?</strong> Enhances concentration with timed sessions.</p>
        <p><strong>Features:</strong> Timer, session tracking, and goal management.</p>
      </div>
      <form onSubmit={handleSendOtp} style={{ display: step === 1 ? 'block' : 'none' }}>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          style={{ width: '100%', padding: 8, marginBottom: 12, borderRadius: 6, border: '1px solid #ccc' }}
        />
        <button type="submit" disabled={!email || loading} style={{ width: '100%', padding: 10, borderRadius: 6, background: '#2d7d46', color: '#fff', border: 'none', fontWeight: 600 }}>
          {loading ? 'Sending OTP...' : 'Send OTP'}
        </button>
        <div style={{ fontSize: 12, color: '#888', marginTop: 8 }}>Check your email for the OTP after submitting.</div>
      </form>
      {step === 2 && (
        <form onSubmit={handleVerifyOtp} style={{ marginTop: 24 }}>
          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={e => setOtp(e.target.value)}
            required
            style={{ width: '100%', padding: 8, marginBottom: 12, borderRadius: 6, border: '1px solid #ccc' }}
          />
          <button type="submit" disabled={!otp || loading} style={{ width: '100%', padding: 10, borderRadius: 6, background: '#2d7d46', color: '#fff', border: 'none', fontWeight: 600 }}>
            {loading ? 'Verifying...' : 'Verify OTP'}
          </button>
        </form>
      )}
      {error && <div style={{ color: 'red', marginTop: 12 }}>{error}</div>}
    </div>
  );
}